import React from "react";
import { Button } from "react-bootstrap";
import DriveFile from "../../../../../interfaces/file/DriveFile";
import { User } from "firebase/auth";
import { SignatureStatus } from "../../../../../interfaces/file/fileSignature/SignatureBox";

interface PDFEditorHeaderProps {
  fileMetadata: DriveFile | null;
  isRequestLoading: boolean;
  handleRequestSignature: () => void;
  currentUser: any;
  authorId: string | undefined;
  setShowConfirmModal: (show: boolean) => void;
  handleSignatureSubmit: () => void;
  userCanEdit: boolean;
  signatureStatus?: SignatureStatus;
  handleBack: () => void;
  hasSignatureBoxes: boolean;
}

const PDFEditorHeader: React.FC<PDFEditorHeaderProps> = ({
  fileMetadata,
  isRequestLoading,
  handleRequestSignature,
  currentUser,
  authorId,
  setShowConfirmModal,
  handleSignatureSubmit,
  userCanEdit,
  signatureStatus,
  handleBack,
  hasSignatureBoxes,
}) => {
  return (
    <div className="top top_bar_flx mb-2">
      <div className="top_left_flx">
        <Button
          variant="secondary"
          className="btn_sm mb-2"
          onClick={handleBack}
        >
          Back
        </Button>
        <h5>Editing: {fileMetadata?.fileName}</h5>
      </div>
      <div className="top_right_flx">
        {userCanEdit && (
          <>
            {signatureStatus && (
              <Button
                variant="secondary"
                className="btn_sm"
                onClick={() => setShowConfirmModal(true)}
              >
                Cancel Request
              </Button>
            )}
            {/* {signatureStatus !== "pending" && ( */}
            <Button
              className="btn_sm"
              variant="primary"
              onClick={handleRequestSignature}
              disabled={!hasSignatureBoxes || isRequestLoading}
              title={!hasSignatureBoxes ? "Add at least one signature box to send." : ""}
            >
              {isRequestLoading ? "Sending..." : "Request Signature"}
            </Button>
            {/* )} */}
            {/* <Button
              variant="primary"
              className="btn_sm"
              onClick={handleSignatureSubmit}
            >
              Sign & Finish
            </Button> */}
          </>
        )}
      </div>
    </div>
  );
};

export default PDFEditorHeader;
